// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MusicFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M81.298 14.481a1.99 1.99 0 0 0-1.61-.457l-43.726 6.843a2 2 0 0 0-1.69 1.976v39.181a11.094 11.094 0 0 0-2.268-1.422c-2.954-1.377-6.496-1.492-9.72-.312-6.315 2.314-9.76 8.88-7.676 14.637.945 2.612 2.91 4.724 5.533 5.947 1.6.746 3.372 1.121 5.173 1.121 1.525 0 3.07-.269 4.547-.81 4.448-1.628 7.46-5.367 8.133-9.446.172-.295.278-.634.278-1V37.381l39.725-6.215v23.915a11.115 11.115 0 0 0-2.143-1.322c-2.956-1.378-6.498-1.49-9.721-.312-6.316 2.316-9.76 8.881-7.677 14.636.945 2.612 2.91 4.725 5.533 5.947 1.6.746 3.372 1.122 5.174 1.122 1.525 0 3.069-.269 4.547-.81 4.6-1.684 7.663-5.625 8.19-9.866.058-.185.097-.378.097-.58V16a2 2 0 0 0-.7-1.519Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default MusicFilled;
